<template>
    <v-modal-slot
             id="show-users-modal"
             @closed="closeModal">
        <template v-slot:modal-title>
            Información del usuario
        </template>

        <template v-slot:modal-content>
            <div class="user-show">
                <div class="user-info row">
                    <div class="col-6 modal-data">Nombre: <span>{{ user.name }}</span></div>
                    <div class="col-6 modal-data">Correo: <span>{{ user.email }}</span></div>
                    <div class="col-6 modal-data">Rol: <span>{{ user.role.name }}</span></div>
                </div>
            </div>
        </template>
    </v-modal-slot>
</template>

<script>
import VModalSlot from "../../general/VModalSlot";

export default {
    name: "UsersListShowModal",
    components: {VModalSlot},
    props: {
        user: {
            type: Object,
            required: true,
        }
    },
    methods: {
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
